import useAppQuery from 'hooks/useAppQuery';
import { RentalConditions } from 'models/RentalCondition';
import { useParams } from 'react-router-dom';
import API from 'services/API';

export const RENTAL_CONDITIONS_BASE_QUERY_KEY = 'rental-conditions';

const useRentalConditionsData = ({ objectType }: { objectType: string }) => {
  const { uid: propertyUid } = useParams();

  const { data: rentalConditionData, isFetching: isLoadingRentalConditions } =
    useAppQuery(
      [RENTAL_CONDITIONS_BASE_QUERY_KEY, objectType, propertyUid],
      async () => {
        const response = await API.get<RentalConditions>(
          `/api/internal/rental-conditions/${propertyUid}`,
          {
            params: {
              objectType,
            },
          },
        );
        return response.data;
      },
      {
        enabled: !!propertyUid,
      },
    );

  return {
    rentalConditionData,
    isLoadingRentalConditions,
  };
};

export default useRentalConditionsData;
